import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

/**
 * Custom hook for tracking responsive breakpoints efficiently
 * Only triggers re-renders when crossing breakpoint boundaries, not on every resize
 */
const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('desktop');

  useEffect(() => {
    const getBreakpoint = (width) => {
      if (width <= 768) return 'mobile';
      if (width <= 1024) return 'tablet';
      return 'desktop';
    };

    const handleResize = debounce(() => {
      const currentBreakpoint = getBreakpoint(window.innerWidth);
      setBreakpoint(prev => prev !== currentBreakpoint ? currentBreakpoint : prev);
    }, 100);

    // Set initial breakpoint
    if (typeof window !== 'undefined') {
      setBreakpoint(getBreakpoint(window.innerWidth));
    }
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
};

export default useBreakpoint;